import type { CityConfig } from "../city-template/types";

export const clovisConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  city: "Clovis",
  state: "New Mexico",
  stateAbbr: "NM",
  slug: "clovis",
  route: "/cities/clovis",
  title: "Emergency Passport Clovis, NM — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Clovis, NM — as fast as 24 hours. A+ BBB rated, registered State Dept. courier serving Cannon AFB personnel, Curry County families, ENMU students, and High Plains travelers.",
  h1: "Emergency & Expedited Passport Services in Clovis, NM",
  heroSubtitle: "Cannon AFB deployment or PCS move coming up fast? Eastern New Mexico University student exchange abroad? Family vacation booked and your passport is expired? We help Clovis residents — from Cannon Air Force Base airmen to Portales families to High Plains agricultural professionals — get their passports fast. As a registered U.S. Department of State courier, we offer a best price guarantee and rates 30-100% lower than FedEx, Staples, and other third-party resellers. As fast as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Wide%20panoramic%20view%20of%20Clovis%20New%20Mexico%20at%20golden%20sunset%20with%20the%20vast%20High%20Plains%20stretching%20to%20the%20horizon%2C%20dramatic%20big%20sky%20with%20golden%20and%20pink%20clouds%2C%20historic%20downtown%20Clovis%20with%20vintage%20Route%2066%20architecture%20and%20the%20historic%20Hotel%20Clovis%20visible%2C%20wind%20turbines%20on%20the%20distant%20plains%2C%20warm%20prairie%20light%20with%20rich%20amber%20tones%2C%20nostalgic%20American%20Southwest%20landscape%20photography&width=1800&height=700&seq=clovis-hero-2026&orientation=landscape",
  heroImageAlt: "Clovis New Mexico High Plains landscape at golden sunset with big sky",
  geoPosition: "34.4049;-103.2052",
  geoPlacename: "Clovis, New Mexico",
  lastModified: "2026-06-07",
  regionalAgency: {
    name: "El Paso Passport Agency",
    address: "700 E San Antonio Ave, El Paso, TX 79901",
    distance: "Located in downtown El Paso, TX — approximately 320 miles southwest of Clovis. Appointments required, typically booked 2+ weeks out.",
  },
  nearbyCitiesZips: [
    { name: "Clovis", zips: "88101, 88102" },
    { name: "Portales", zips: "88130" },
    { name: "Texico", zips: "88135" },
    { name: "Cannon AFB", zips: "88103" },
    { name: "Melrose", zips: "88124" },
    { name: "Fort Sumner", zips: "88119" },
    { name: "Tucumcari", zips: "88401" },
    { name: "Lubbock, TX", zips: "79401–79499" },
  ],
  benefits: [
    { icon: "ri-flashlight-line", title: "24-Hour Eastern NM Emergency Processing", desc: "Reserved courier access — as fast as 24 hours for Clovis-area travelers with immediate departures. No driving to El Paso required." },
    { icon: "ri-shield-line", title: "Cannon AFB Military Support", desc: "We serve Cannon Air Force Base airmen, families, and civilian contractors with expedited passport processing for deployments, PCS moves, and official travel." },
    { icon: "ri-graduation-cap-line", title: "ENMU Student & Study Abroad", desc: "Eastern New Mexico University Greyhounds studying abroad get student-friendly expedited service for program deadlines." },
    { icon: "ri-flight-takeoff-line", title: "LBB & ABQ Airport Connectivity", desc: "Clovis residents use Lubbock (100 miles) or Albuquerque (220 miles) for international connections. We coordinate around both airports." },
  ],
  internalLinks: [
    { name: "Fast passport services in Albuquerque, NM", route: "/cities/albuquerque" },
    { name: "Expedited passport in Lubbock, TX", route: "/cities/lubbock" },
    { name: "New Mexico passport services overview", route: "/states/new-mexico" },
    { name: "Texas passport services overview", route: "/states/texas" },
  ],
  fpcOfficeAddress: "Serving Clovis via secure registered courier with direct agency access",
  fpcOfficeNote: "Fast Passport Center serves Clovis via secure registered courier with direct access to passport agencies. Our registered couriers hand-deliver your documents — meaning you get faster results without the appointment wait. Clovis residents can ship from any UPS Store, FedEx Office, or post office location across Curry County and eastern New Mexico.",
  fpcOfficeDistance: "Serving Clovis, Portales, Texico, Cannon AFB, Melrose, Fort Sumner, Tucumcari, and all Curry County communities",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Clovis and the greater eastern New Mexico High Plains region. From downtown Clovis and the historic Main Street corridor to Cannon AFB — we serve all of Curry County and Roosevelt County. Our courier service eliminates the need to drive to a distant passport agency in El Paso.",
  nearbyCitiesIntro: "We serve Clovis and all surrounding communities including Portales, Texico, Cannon AFB, Melrose, Fort Sumner, and Tucumcari. We also serve travelers across the Texas border in Lubbock, Muleshoe, and Farwell who need emergency passports.",
  howItWorksIntro: "From start to finish, we make getting an expedited passport in Clovis as simple as possible — with the efficiency and reliability Cannon AFB airmen, ENMU students, and High Plains agricultural families need. Because we are a registered U.S. Department of State courier (not a reseller like FedEx or Staples), we pass those savings directly to you with our best price guarantee. Most Clovis travelers start online and ship documents overnight — no office visit required for most services.",
  mistakesIntro: "Clovis travelers encounter unique passport issues — everything from Cannon AFB deployment documentation to ENMU study-abroad deadline crunches. Here are the most common passport mistakes we see from this area.",
  testimonialsIntro: "Clovis travelers — from Cannon airmen to ENMU Greyhounds to High Plains families — trust us when their international departure is days away.",
  faqIntro: "Have questions about expedited passports in Clovis, NM? Here are the most common ones we hear from Curry County-area travelers.",
  statePageRoute: "/states/new-mexico",
  statePageName: "New Mexico",
  servicesIntro: "Whether you need a renewal before a Lubbock connection, an emergency passport for a last-minute deployment, or a first-time passport for an ENMU study-abroad program — Fast Passport Center handles it with reserved courier submission availability. As a registered State Department courier (not a reseller), we guarantee the best price and typically cost 30-100% less than FedEx, Staples, and other third-party passport courier resellers.",
  dmvWebsite: "https://www.currycounty.org/departments/assessor/",
  dmvLabel: "Curry County Assessor — Motor Vehicle Information",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Local Area", href: "#service-area" },
    { label: "Travel", href: "#travel-timing" },
    { label: "Destinations", href: "#destinations" },
    { label: "Reviews", href: "#testimonials" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Compare", href: "#comparison" },
    { label: "Mistakes", href: "#mistakes" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Predictable turnaround", "Ideal for upcoming trips", "Document review included", "Dedicated agent assigned to your case", "Daily status updates", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Faster than self-service", "Good for planned travel", "Document review included", "Dedicated agent assigned", "Daily status updates", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent", "Updates only by mail letter", "Cannot upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins allowed", "Life-or-death emergencies only", "Bereavement or medical crisis", "Requires travel to El Paso (320 miles) — essentially a full-day trip"],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-time-line",
      title: "Emergency Passport",
      description: "Cannon AFB deployment in two days? Family emergency requiring travel? Our emergency courier service submits via reserved agency slots — as fast as 24 hours for Clovis-area travelers.",
      bullets: ["As fast as 24 hours", "Reserved agency submission", "Live case tracking"],
      badge: "Same-Day Available",
      link: "https://fastpassportcenter.com/checkout/?passport=emergency-passport",
    },
    {
      icon: "ri-refresh-line",
      title: "Passport Renewal",
      description: "Already hold a U.S. passport? We help Clovis residents renew fast — no agency visit required for most renewals. Perfect for Cannon personnel and Curry County families.",
      bullets: ["Eligible for expedited processing", "Ship documents overnight", "Professional document review"],
      badge: "Most Common",
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-file-add-line",
      title: "New Passport",
      description: "First-time applicants require an in-person acceptance clerk visit. We guide Clovis residents through every step with clear instructions for the nearest acceptance location.",
      bullets: ["Step-by-step checklist provided", "Acceptance clerk guidance", "Expedited after clerk visit"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-search-eye-line",
      title: "Lost or Stolen Passport",
      description: "Replacements require additional forms. We guide you through DS-64 and everything needed to avoid costly mistakes — so your deployment or travel stays on track.",
      bullets: ["DS-64 form guidance included", "Replacement processing", "Urgent timelines available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Minors require parental participation and an in-person acceptance step. We provide clear instructions so your military family or High Plains family trip stays on schedule.",
      bullets: ["Both parents must consent", "Clear checklist provided", "Expedited options available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-edit-line",
      title: "Name Change",
      description: "After marriage, divorce, or a legal name change — we assist with corrected passports. Common after military spouse name changes.",
      bullets: ["Marriage certificate guidance", "Legal name change support", "Document review included"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
    {
      icon: "ri-book-2-line",
      title: "Second Passport",
      description: "Need a second passport for frequent travel? Ideal for Cannon AFB personnel and DoD contractors traveling internationally while primary passport is in visa processing.",
      bullets: ["Frequent traveler solutions", "Backup travel document", "Expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=second-passport",
    },
    {
      icon: "ri-file-damage-line",
      title: "Damaged Passport",
      description: "Replacing a significantly damaged passport is faster than you think. We guide eastern NM travelers through the process so your itinerary stays on track.",
      bullets: ["Damaged passport replacement", "Document review included", "Expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=damaged-passport",
    },
    {
      icon: "ri-id-card-line",
      title: "Passport Card",
      description: "The passport card is a wallet-size travel document for land and sea crossings to Canada, Mexico, and the Caribbean. Same courier service as book passports.",
      bullets: ["Wallet-size convenience", "Land and sea travel", "Same expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-card",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Clovis NM", description: "Urgent passport processing for Clovis New Mexico travelers with immediate departure needs." },
    { name: "Expedited Passport Renewal Clovis NM", description: "Fast passport renewal for Clovis New Mexico residents with a previously-issued passport." },
    { name: "First-Time Passport Clovis NM", description: "New passport application services for Clovis New Mexico residents applying for their first passport." },
    { name: "Child Passport Clovis NM", description: "Minor passport services for Clovis NM families with children under 16." },
    { name: "Name Change Passport Clovis NM", description: "Passport name correction for Clovis residents." },
    { name: "Second Passport Clovis NM", description: "Second passport services for Cannon AFB personnel and frequent travelers." },
  ],
  testimonials: [
    {
      name: "SSgt David R.",
      location: "Cannon AFB",
      rating: 5,
      text: "Got short-notice deployment orders and needed a new passport fast. Fast Passport Center handled it in 48 hours while I was focused on pre-deployment prep. The military support was outstanding.",
      service: "Emergency Passport — Military",
    },
    {
      name: "The Johnson Family",
      location: "Clovis",
      rating: 5,
      text: "We are an Air Force family facing a PCS move to Germany. Three of us needed passport renewals simultaneously. They coordinated the whole process — all arrived in 6 days.",
      service: "Family PCS Passport Services",
    },
    {
      name: "Amanda G.",
      location: "Portales (ENMU)",
      rating: 5,
      text: "I am an ENMU education major accepted into a student teaching program in Costa Rica. My application was flagged for a documentation error and they caught it before submission. Arrived in 5 days.",
      service: "Student First-Time Passport",
    },
    {
      name: "Robert T.",
      location: "Clovis",
      rating: 5,
      text: "Dairy industry conference in the Netherlands was booked 10 days out and my passport had expired. They got it done in 4 days. I made the conference and sealed a major supplier deal.",
      service: "Emergency Passport Renewal",
    },
  ],
  facilities: [
    {
      id: "cv-1",
      name: "Clovis Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "417 Gidding St",
      city: "Clovis",
      state: "NM",
      zip: "88101",
      phone: "(575) 769-0771",
      hours: "Mon–Fri 9:00 AM – 4:00 PM (appointment required)",
      distance: "Downtown Clovis",
      website: "https://tools.usps.com/find-location.htm?location=1367356",
      websiteLabel: "USPS Location",
      notes: "Primary passport acceptance facility for Clovis and Curry County. Passport photos available on-site. Serves downtown Clovis, Cannon AFB personnel, and all eastern NM communities. Appointment recommended.",
      icon: "ri-mail-line",
    },
    {
      id: "cv-2",
      name: "Portales Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "116 W 1st St",
      city: "Portales",
      state: "NM",
      zip: "88130",
      phone: "(575) 356-4401",
      hours: "Mon–Fri 9:00 AM – 4:00 PM",
      distance: "Portales — Roosevelt County",
      website: "https://tools.usps.com/find-location.htm?location=1376607",
      websiteLabel: "USPS Location",
      notes: "Serves Portales, ENMU students, and Roosevelt County. Photo services available. Less busy than Clovis main — shorter wait times possible. Call ahead.",
      icon: "ri-mail-line",
    },
    {
      id: "cv-3",
      name: "Curry County Clerk",
      type: "County Clerk Passport Acceptance",
      address: "700 N Main St, Suite 7",
      city: "Clovis",
      state: "NM",
      zip: "88101",
      phone: "(575) 763-5591",
      hours: "Mon–Fri 8:00 AM – 5:00 PM",
      distance: "Downtown Clovis — Curry County",
      website: "https://www.currycounty.org/departments/county-clerk/",
      websiteLabel: "Curry County Clerk",
      notes: "Official county clerk passport acceptance facility. No photo services on-site — bring completed passport photos. Serves all Curry County. Appointment recommended.",
      icon: "ri-government-line",
    },
    {
      id: "cv-4",
      name: "Cannon AFB Military Personnel Section",
      type: "Military Passport Services (Official Travel Only)",
      address: "110 E Albright Ave, Bldg 600",
      city: "Cannon AFB",
      state: "NM",
      zip: "88103",
      phone: "Contact unit orderly room or MPS",
      hours: "Mon–Fri 7:30 AM – 4:30 PM",
      distance: "Cannon Air Force Base",
      website: "https://www.cannon.af.mil/",
      websiteLabel: "Cannon AFB Website",
      notes: "Handles official (no-fee) passports for active duty personnel on PCS or deployment orders. Tourist passport applications may still require a civilian acceptance facility. Contact MPS for current processing times.",
      icon: "ri-shield-line",
    },
    {
      id: "cv-5",
      name: "Lubbock Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "411 Avenue L",
      city: "Lubbock",
      state: "TX",
      zip: "79401",
      phone: "(806) 472-1751",
      hours: "Mon–Fri 9:00 AM – 5:00 PM (appointment required)",
      distance: "Lubbock, TX — 100 miles from Clovis",
      website: "https://tools.usps.com/find-location.htm?location=1376536",
      websiteLabel: "USPS Location",
      notes: "Alternative acceptance facility in Lubbock. Convenient when traveling south for LBB airport departures. Full photo services. Book ahead — busiest acceptance facility in the South Plains region.",
      icon: "ri-mail-line",
    },
    {
      id: "cv-6",
      name: "Tucumcari Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "220 S 1st St",
      city: "Tucumcari",
      state: "NM",
      zip: "88401",
      phone: "(575) 461-0375",
      hours: "Mon–Fri 9:00 AM – 4:00 PM",
      distance: "Tucumcari — 50 miles west of Clovis",
      website: "https://tools.usps.com/find-location.htm?location=1376770",
      websiteLabel: "USPS Location",
      notes: "Alternative acceptance facility for western Curry County and Quay County residents. Photos may not be available — call ahead to confirm services.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Required", agency: "Yes — typically booked 2+ weeks out, driving to El Paso (320 miles) required", fpc: "No appointment needed to start" },
    { feature: "In-Person Visit", agency: "Required — drive to El Paso, TX (320 miles — full day trip)", fpc: "Most Clovis travelers ship documents overnight" },
    { feature: "Processing Speed", agency: "Life-or-death emergencies only — strict eligibility with proof of travel", fpc: "As fast as 24 hours — multiple speed options" },
    { feature: "Document Review", agency: "None — errors cause rejection and delay", fpc: "Professional review to reduce processing delays" },
    { feature: "Courier Access", agency: "Not available to the public — agency serves emergencies only", fpc: "Reserved daily submission as registered courier" },
    { feature: "Predictability", agency: "Appointments can be cancelled or unavailable — no guarantee", fpc: "Predictable processing based on selected speed" },
    { feature: "Who Can Use It", agency: "Strict eligibility — urgent travel only with proof of departure", fpc: "Most U.S. citizens with required documentation" },
    { feature: "Cost vs Resellers", agency: "Government fees only — but you handle shipping and 640-mile round trip", fpc: "Best price guarantee — 30-100% less than FedEx, Staples & resellers" },
    { feature: "Eastern NM Specific", agency: "Generic — no Cannon AFB, ENMU, or High Plains expertise", fpc: "Full Cannon AFB/ENMU/agricultural knowledge built in" },
  ],
  comparisonExtraColumns: undefined,
  mistakes: [
    {
      icon: "ri-error-warning-line",
      title: "Assuming Cannon AFB Handles Tourist Passports",
      description: "Cannon AFB MPS handles official (no-fee) passports for military orders only. Many service members and families assume they can get tourist passports on base. They cannot — a civilian acceptance facility visit is required.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Using DS-82 When DS-11 Is Required",
      description: "Clovis applicants often attempt the simpler renewal form when their passport was issued at 15 or younger. A rejected form costs 1-2 weeks. We review before you submit.",
    },
    {
      icon: "ri-error-warning-line",
      title: "PCS Move Passport Timing Crunch",
      description: "Military families facing PCS moves to Germany, Japan, or Korea often discover expired tourist passports 2-3 weeks before departure. Standard processing cannot meet that timeline. We provide accelerated PCS-family service.",
    },
    {
      icon: "ri-error-warning-line",
      title: "ENMU Study Abroad Last-Minute Applications",
      description: "ENMU students frequently apply for passports in the final month before program orientation. A single documentation error causes a 2-week delay. We provide a student-specific accelerated checklist.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Not Accounting for Regional Airport Distance",
      description: "Lubbock Preston Smith International (LBB) is 100 miles from Clovis. A passport issue discovered there means you miss your connection. Your passport must be in hand before you leave Curry County.",
    },
  ],
  steps: [
    { number: "01", icon: "ri-computer-line", title: "Start Your Order Online", description: "Choose the processing speed that fits your travel date and complete your secure order from home, office, or base housing." },
    { number: "02", icon: "ri-file-list-3-line", title: "We Confirm & Send Your Checklist", description: "We confirm your details and provide a personalized checklist tailored to your travel — military, student, or family." },
    { number: "03", icon: "ri-send-plane-line", title: "Ship Your Documents Overnight", description: "Send your documents using overnight shipping. Most Clovis clients ship from home — no office visit needed beyond acceptance." },
    { number: "04", icon: "ri-building-2-line", title: "We Submit Through Reserved Access", description: "We submit through reserved agency availability — so you do not drive 320 miles to El Paso." },
    { number: "05", icon: "ri-passport-line", title: "Your Passport Is Completed", description: "Your passport is completed within the timeframe you selected. Predictable, reliable, and fast." },
  ],
  faqs: [
    { q: "How fast can I get a passport in Clovis?", a: "We offer Clovis-area clients expedited processing as fast as 24 hours. Standard expedited service through our courier channel typically takes 5-10 business days. We review your documents before submission to catch errors." },
    { q: "Is there a passport agency near Clovis?", a: "No. The closest agency is in El Paso, TX (320 miles). Our registered courier service brings agency-level speed to Clovis without the day-long drive." },
    { q: "Where can I get passport acceptance in Clovis?", a: "Clovis has acceptance at the Main Post Office on Gidding Street, the Curry County Clerk, and the Portales Post Office. Cannon AFB MPS handles official military passports only. We maintain an updated facility list." },
    { q: "Can you help Cannon AFB personnel with military passports?", a: "Yes. We assist active duty airmen, dependents, and civilian contractors with both official (no-fee) passport guidance and tourist passport processing. For official passports, we coordinate with your unit and MPS. For tourist passports, we handle the entire expedited process." },
    { q: "What airport do Clovis travelers use for international flights?", a: "Most Clovis residents drive to Lubbock Preston Smith International (LBB, 100 miles) or Albuquerque Sunport (ABQ, 220 miles). Both airports connect to DFW, DEN, and PHX for international gateways." },
    { q: "What documents do Clovis applicants need?", a: "New passport: certified birth certificate, government-issued photo ID, DS-11 form, and passport photo. Renewal: DS-82 form, current passport, and passport photo. Child passport: DS-11, birth certificate, both parents or notarized consent, and photos." },
    { q: "Can you help ENMU students with study abroad?", a: "Yes. We regularly assist ENMU students from the Portales campus with expedited passports for study abroad, student teaching, and international exchange programs. We understand the tight orientation-to-departure timeline." },
    { q: "How do I check my passport status?", a: "Once submitted, we provide tracking at every stage. You can also check the State Department's online passport status system at travel.state.gov." },
    { q: "What is the best price for expedited passport service in Clovis?", a: "Government fees are $130 + $60 expedite fee. Our courier fee covers document review, overnight shipping, and State Department submission. Total cost is typically 30-100% lower than FedEx, Staples, and other third-party resellers." },
    { q: "How do I get a passport photo in Clovis?", a: "Passport photos are available at Walgreens, CVS, Walmart, and the UPS Store in Clovis. The Main Post Office also offers photo services. We recommend confirming photo standards compliance before visiting." },
  ],
  travelTiming: {
    title: "Travel & Passport Timing for Clovis Residents",
    intro: "Clovis' unique position as a High Plains community anchored by Cannon AFB and ENMU creates travel dynamics unlike anywhere else in New Mexico. Here is what Clovis travelers need to know.",
    cards: [
      {
        icon: "ri-flight-takeoff-line",
        title: "LBB — Lubbock Preston Smith International Airport",
        subtitle: "100 miles south, primary international gateway for Clovis",
        description: "Lubbock's airport is the go-to departure point for most Clovis international travelers. With American Eagle to DFW and United Express to DEN and IAH, LBB connects the High Plains to the world. The 100-mile drive takes about 90 minutes down US-84. Passport issues must be resolved before departure — LBB has no passport services.",
        tip: "Check passport validity before booking. A 90-minute drive to LBB followed by a missed connection at DFW because of a passport problem is entirely preventable with advance planning.",
      },
      {
        icon: "ri-shield-line",
        title: "Cannon AFB — Military Travel & PCS Moves",
        subtitle: "27th Special Operations Wing, Air Force Special Operations Command",
        description: "Cannon AFB is home to the 27th Special Operations Wing under AFSOC. Deployments, PCS moves to overseas bases (Ramstein, Aviano, Kadena, Osan), and temporary duty assignments create constant passport demand. Official no-fee passports are handled by the MPS, but tourist passports for family members and personal travel require the same civilian process as everyone else.",
        tip: "Military families should maintain current tourist passports for all family members regardless of current orders. PCS orders can come with 4-6 weeks notice — not enough time for standard tourist passport processing for dependents.",
      },
      {
        icon: "ri-graduation-cap-line",
        title: "ENMU — Eastern New Mexico University",
        subtitle: "Portales campus, Greyhound student travel programs",
        description: "ENMU's main campus in Portales (20 miles from Clovis) sends students abroad each year for education, agriculture, and communication programs. Many ENMU students are first-generation college students who have never held a passport. The window between program acceptance and departure is often 6-10 weeks — tight for standard processing timelines.",
        tip: "First-time applicants must visit an acceptance facility. The Portales Post Office on 1st Street is the most convenient option for ENMU students — just blocks from campus.",
      },
      {
        icon: "ri-plant-line",
        title: "High Plains Agriculture & International Business",
        subtitle: "Dairy, cattle, and agricultural export economy",
        description: "Curry and Roosevelt counties are among the top agricultural producers in New Mexico, with a massive dairy and cattle industry. International agricultural conferences, equipment supplier visits to Europe, and trade missions to Canada, Mexico, and the EU create regular passport needs for agricultural professionals who rarely think about international travel until it is scheduled.",
        tip: "Agricultural professionals attending international trade shows and equipment training — especially in the Netherlands, Germany, or Canada — should check passport validity at least 3 months before any scheduled event.",
      },
    ],
    callout: {
      icon: "ri-map-pin-2-line",
      title: "Clovis & Cross-Border Texas Access",
      description: "Clovis sits just 9 miles from the Texas border. Many residents regularly cross into Texas for shopping, medical care, and airport access in Lubbock and Amarillo. This bi-state lifestyle means Clovis travelers have facility options in both New Mexico and Texas — we help you choose the most convenient acceptance facility and shipping location regardless of which state it is in.",
    },
  },
  destinations: {
    title: "Where Clovis Travelers Go — And Why Passports Get Urgent",
    intro: "Clovis' unique mix of military, university, and agricultural communities creates travel patterns specific to the High Plains. Here are the most common international destinations.",
    stats: [
      { stat: "48%", label: "of Clovis expedited requests are Cannon AFB related — deployments, PCS, or military family travel" },
      { stat: "2-4 Weeks", label: "average lead time Clovis travelers have from booking to international departure" },
      { stat: "May-Aug", label: "peak season — PCS season, summer vacation, and ENMU study abroad overlap" },
      { stat: "36 Hours", label: "shortest turnaround for a Cannon AFB airman with deployment orders" },
    ],
    destinations: [
      { name: "Germany", context: "Ramstein AB and Spangdahlem AB PCS moves, European agricultural tech conferences", urgency: "PCS orders come with 4-8 weeks notice", icon: "ri-map-pin-2-line" },
      { name: "Japan & South Korea", context: "Kadena AB and Osan AB assignments, AFSOC Pacific operations, Asian ag tech", urgency: "Overseas assignments have rigid report dates", icon: "ri-map-pin-2-line" },
      { name: "Mexico", context: "Family heritage visits, Cancun resort vacations, spring break", urgency: "Holiday and summer family visits create seasonal demand", icon: "ri-map-pin-2-line" },
      { name: "United Kingdom & Netherlands", context: "Dairy and ag equipment trade shows, European agricultural conferences", urgency: "Conference dates are fixed months in advance", icon: "ri-map-pin-2-line" },
      { name: "Italy", context: "Aviano AB assignments, NATO operations, European vacation add-ons", urgency: "Military travel has hard no-fail deadlines", icon: "ri-map-pin-2-line" },
      { name: "Caribbean & Costa Rica", context: "ENMU study abroad programs, family resort vacations, cruise departures", urgency: "Student programs have fixed orientation dates", icon: "ri-map-pin-2-line" },
    ],
    crossLinksTitle: "Explore Other New Mexico Service Areas",
    crossLinksDesc: "We serve travelers across the Land of Enchantment with the same fast, reliable passport processing.",
    crossLinks: [
      { name: "Albuquerque", route: "/cities/albuquerque" },
      { name: "Lubbock, TX", route: "/cities/lubbock" },
      { name: "Santa Fe", route: "/santa-fe" },
    ],
  },
  photoLocations: [
    { name: "Walgreens — Prince St", address: "2801 N Prince St, Clovis, NM 88101", hours: "Daily 8 AM – 10 PM", website: "https://www.walgreens.com/photo/passport-photo", websiteLabel: "Walgreens Photo" },
    { name: "CVS Pharmacy — Clovis", address: "2108 N Prince St, Clovis, NM 88101", hours: "Daily 8 AM – 10 PM", website: "https://www.cvs.com/photo/passport-photos", websiteLabel: "CVS Photo" },
    { name: "Walmart — Clovis", address: "3728 N Prince St, Clovis, NM 88101", hours: "Daily 6 AM – 11 PM", website: "https://www.walmart.com/cp/passport-photos/1055304", websiteLabel: "Walmart Photo" },
    { name: "The UPS Store — Clovis", address: "2708 N Prince St, Clovis, NM 88101", hours: "Call for hours", website: "https://www.theupsstore.com/", websiteLabel: "UPS Store" },
    { name: "Walgreens — Portales", address: "1620 S Avenue D, Portales, NM 88130", hours: "Daily 8 AM – 10 PM", website: "https://www.walgreens.com/photo/passport-photo", websiteLabel: "Walgreens Photo" },
  ],
  dmvLocations: [
    {
      name: "Curry County MVD — Clovis",
      address: "700 N Main St, Clovis, NM 88101",
      hours: "Mon–Fri, 8:00 AM – 4:00 PM",
      note: "Driver licenses, REAL ID, vehicle registration. Located at the County complex. Appointment recommended.",
      featured: true,
    },
    {
      name: "New Mexico MVD — Portales",
      address: "100 W 1st St, Portales, NM 88130",
      hours: "Mon–Fri, 8:00 AM – 4:30 PM",
      note: "Roosevelt County MVD office. REAL ID available. Appointment recommended.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "LBB",
      name: "Lubbock Preston Smith International Airport",
      distance: "About 100 miles south of Clovis",
      address: "5401 N Martin L King Blvd, Lubbock, TX 79403",
      note: "Primary international gateway for Clovis travelers. American Eagle to DFW, United Express to DEN and IAH. About 90 minutes from Clovis via US-84.",
      flightUrl: "https://www.flylbb.com/",
      flightLabel: "LBB Airport Website",
      featured: true,
    },
    {
      code: "ABQ",
      name: "Albuquerque International Sunport",
      distance: "About 220 miles west of Clovis",
      address: "2200 Sunport Blvd, Albuquerque, NM 87106",
      note: "New Mexico's largest airport. Direct flights to Mexico and domestic connections to all major international gateways. About 3.5 hours from Clovis via I-40.",
      flightUrl: "https://www.abqsunport.com/",
      flightLabel: "ABQ Airport Website",
      featured: false,
    },
  ],
  vitalRecordsLinks: [
    {
      icon: "ri-user-smile-line",
      label: "Birth Certificate",
      desc: "Request certified birth certificates from the New Mexico Department of Health. Online, mail, or in-person options available for Curry County.",
      url: "https://www.nmhealth.org/about/erd/bvrhs/vrp/",
    },
    {
      icon: "ri-file-list-2-line",
      label: "Death Certificate",
      desc: "Obtain certified death certificates through the NM Department of Health Vital Records. Required for estate and legal matters in Curry County.",
      url: "https://www.nmhealth.org/about/erd/bvrhs/vrp/",
    },
    {
      icon: "ri-hearts-line",
      label: "Marriage Certificate",
      desc: "Request marriage license records from the Curry County Clerk. Certified copies available for name changes.",
      url: "https://www.currycounty.org/departments/county-clerk/",
    },
    {
      icon: "ri-file-copy-line",
      label: "Divorce Decree",
      desc: "Obtain certified divorce records through the 9th Judicial District Court. Required for name change passport corrections.",
      url: "https://ninthdistrictcourt.nmcourts.gov/",
    },
  ],
};